/* ------------------------------------------------------------------------------
@name: API_URL
@description: API_URL
--------------------------------------------------------------------------------- */

import { BASE_URL } from "./BASE_URL";

// const URL_API = "http://192.168.100.86/rzf-medis-api/v1/";

export const API_URL = {
  /* ---- APP API ---- */
  // -- login
  login: `${BASE_URL}login/process`,
  logout: `${BASE_URL}logout`,

  // -- reseller
  resellerGet: `${BASE_URL}reseller/get`,
  resellerAdd: `${BASE_URL}reseller/add`,
  resellerEdit: `${BASE_URL}reseller/edit`,
  resellerDelete: `${BASE_URL}reseller/delete`,

  // -- customer
  customerGet: `${BASE_URL}customer/get`,
  customerAdd: `${BASE_URL}customer/add`,
  customerEdit: `${BASE_URL}customer/edit`,
  customerDelete: `${BASE_URL}customer/delete`,

  // -- order
  order: `${BASE_URL}order`,
  orderGet: `${BASE_URL}order/get`,
  orderAdd: `${BASE_URL}order/add_data`,
  orderEdit: `${BASE_URL}order/edit_data`,
  orderScan: `${BASE_URL}order/scan_data`,
  orderDelete: `${BASE_URL}order/delete`,
  updateStatus: `${BASE_URL}order/update_status`,
  exportData: `${BASE_URL}order/export`,
  previewOrderCode: BASE_URL + "order/preview_order_code",
  orderEditMultiple: BASE_URL + "order/edit_multiple",

  // -- dashboard
  dashboardOverview: `${BASE_URL}dashboard/overview`,
  dashboardStats: `${BASE_URL}dashboard/stats`,
  dashboardTopLists: `${BASE_URL}dashboard/top_lists`,
  dashboardCharts: `${BASE_URL}dashboard/charts`,

  // -- user
  userGet: `${BASE_URL}admin/get`,
  userAdd: `${BASE_URL}admin/add_data`,
  userEdit: `${BASE_URL}admin/edit_data`,
  userDelete: `${BASE_URL}admin/delete_data`,

  // role
  roleGet: `${BASE_URL}role/get`,
  roleAdd: `${BASE_URL}role/add_data`,
  roleEdit: `${BASE_URL}role/edit_data`,
  roleDelete: `${BASE_URL}role/delete_data`,
  roleMenus: `${BASE_URL}role/get_menus`,

  // gallery
  galleryGet: `${BASE_URL}gallery/get`,
  galleryDelete: `${BASE_URL}gallery/delete`,

  // product
  productGet: `${BASE_URL}product/get`,
  productAdd: `${BASE_URL}product/add`,
};
